<button type="button" class="btn btn-outline-secondary modify-column-btn" (click)="openModifyColumnModal()" triggers="mouseenter:mouseleave" placement="auto" container="body"
  [ngbPopover]="'title.modify-columns-visible'| translate">
  <i class="fas fa-columns" aria-hidden="true"></i>
</button>